/**
 * Route visibility for Header, Footer, MobileMenu (US-2.H1, US-2.F1).
 * Hide nav/footer links that target pages not available in the selected language.
 *
 * API contract: No backend endpoint exists yet for "pages available per language".
 * When added, plug into getVisibleNavRoutes / getVisibleFooterLinks.
 */

export interface NavItem {
  path: string
  labelKey: string
}

export interface FooterGroup {
  titleKey: string
  links: NavItem[]
}

/** Main nav items. Order preserved. */
export const MAIN_NAV: NavItem[] = [
  { path: '/', labelKey: 'common.home' },
  { path: '/islam-definition', labelKey: 'islamDefinition.nav' },
  { path: '/doubt-responses', labelKey: 'doubtResponses.nav' },
  { path: '/library', labelKey: 'common.library' },
  { path: '/quran', labelKey: 'common.quran' },
  { path: '/videos', labelKey: 'common.videos' },
  { path: '/about', labelKey: 'common.about' },
]

/** Services dropdown items. Donations excluded (no dead link). */
export const SERVICES_NAV: NavItem[] = [
  { path: '/services/prayer', labelKey: 'prayer.title' },
  { path: '/services/zakat', labelKey: 'zakat.title' },
]

/** Footer "Important links" group */
export const FOOTER_IMPORTANT: NavItem[] = [
  { path: '/about', labelKey: 'common.about' },
  { path: '/references', labelKey: 'footer.references' },
]

/** Footer "Services" group */
export const FOOTER_SERVICES: NavItem[] = [
  { path: '/services/prayer', labelKey: 'prayer.title' },
  { path: '/services/zakat', labelKey: 'zakat.title' },
]

/**
 * Returns main nav items visible for the given language.
 * Currently no API: all configured routes are visible.
 * TODO: Filter by backend "pages available per language" when implemented.
 */
export function getVisibleNavRoutes(_languageCode: string): NavItem[] {
  return MAIN_NAV
}

/**
 * Returns services dropdown items visible for the given language.
 */
export function getVisibleServicesRoutes(_languageCode: string): NavItem[] {
  return SERVICES_NAV
}

/**
 * Returns footer link groups with visible links only.
 * Social links are always visible (external); not included here.
 */
export function getVisibleFooterLinks(_languageCode: string): {
  important: NavItem[]
  services: NavItem[]
} {
  return {
    important: FOOTER_IMPORTANT,
    services: FOOTER_SERVICES,
  }
}
